import { applyMiddleware, createStore, compose } from 'redux';
import { getAppObj, getAuthToken } from './utils/utils';
import axios from 'axios';
import axiosMiddleware from 'redux-axios-middleware';
import reduxThunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import reducer from './reducers';
import { handleSessionExpired } from './actions/user';
import config from './constants/config';
import endpoints from './constants/endpoints';

const windowExist = typeof window !== 'undefined';

const composeEnhancers =
  windowExist && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const client = axios.create({
  baseURL: config.getApiUrl(),
  responseType: 'json'
});

if (windowExist) getAppObj().axiosDefaults = client.defaults;

const enhancer = composeEnhancers(
  applyMiddleware(promise(), axiosMiddleware(client), reduxThunk)
);

const store = createStore(reducer, enhancer);

export default store;

client.interceptors.request.use((config) => {
  const requestToken = config.headers['x-auth-token'];
  config.headers['x-auth-token'] = requestToken || getAuthToken().token;
  return config;
});

const excludedUrls = [
  endpoints.me,
  endpoints.refresh,
  endpoints.authenticate,
  endpoints.passwordReset
];

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const statusCode = error.response.status;

    if (statusCode === 401) {
      const url = error.response.config.url.split(/[?#]/)[0];
      const exceptions = excludedUrls.includes(url);

      if (!exceptions) {
        store.dispatch(handleSessionExpired());
      }

      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/